import * as React from 'react';
import type { FileRejection } from 'react-dropzone';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { ALLOWED_FILE_TYPES_MIME } from '@acceligentllc/shared/enums/fileType';

import type { RootState } from 'af-reducers';

import { Button } from '@acceligentllc/storybook';

import CustomModal from 'af-components/CustomModal';
import Dropzone from 'af-components/Dropzone';
import FileUploadMessage from 'af-components/Dropzone/FileUploadMessage';

interface OwnProps {
	showModal: boolean;
	onCancel: () => void;
	error: string | undefined;
	onDrop: (acceptedFiles: File[], fileRejections: FileRejection[]) => void;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const UploadDocumentModal: React.FC<Props> = (props) => {
	const {
		showModal,
		onCancel,
		uploadProgress,
		error,
		onDrop,
	} = props;

	const uploading = uploadProgress !== 100 && uploadProgress !== 0;

	const style: Partial<React.CSSProperties> | undefined = uploading
		? { padding: '1px', background: `linear-gradient(to right, #9FCAFF ${uploadProgress}%, transparent ${uploadProgress}% 100%)` }
		: undefined;

	return (
		<CustomModal
			closeModal={onCancel}
			modalStyle="info"
			showModal={showModal}
			size="md"
		>
			<CustomModal.Header
				closeModal={onCancel}
				title="Upload Document"
			/>
			<CustomModal.Body>
				<Dropzone
					allowedTypes={ALLOWED_FILE_TYPES_MIME}
					className="dropzone-element"
					onDrop={onDrop}
					style={style}
				>
					<FileUploadMessage
						error={error}
						uploading={uploading}
					/>
				</Dropzone>
			</CustomModal.Body>
			<CustomModal.Footer>
				<Button
					label="Cancel"
					onClick={onCancel}
					style="secondary"
				/>
			</CustomModal.Footer>
		</CustomModal>
	);
};

function mapStateToProps(state: RootState) {
	return {
		uploadProgress: state.http.uploadProgress,
	};
}

const connector = connect(mapStateToProps);

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	connector
);

export default enhance(UploadDocumentModal);
